import { useState } from "react";
import { ArrowDown, CalendarDays, MapPin } from "lucide-react";
import { camp } from "@/data/camp";
import RegisterLink from "@/components/RegisterLink";

const heroLines = ["ALABAMA", "ELITE", "JUNIOR", "GOLF CAMP"];

function HeroSection() {
  const [tilt, setTilt] = useState({ x: 0, y: 0 });

  const handlePointerMove = (event) => {
    if (window.innerWidth < 900) return;
    const rect = event.currentTarget.getBoundingClientRect();
    const x = (event.clientX - rect.left) / rect.width - 0.5;
    const y = (event.clientY - rect.top) / rect.height - 0.5;
    setTilt({ x: x * 8, y: y * 6 });
  };

  return (
    <section className="hero-section" id="home" onPointerMove={handlePointerMove} onPointerLeave={() => setTilt({ x: 0, y: 0 })} data-testid="hero-section">
      <span className="hero-grid-bg" aria-hidden="true" />
      <div className="hero-layout page-width">
        <div className="hero-copy">
          <div className="hero-status"><span className="status-dot" />{camp.eventName} <span className="status-divider">/</span> {camp.registrationEnabled ? "Registration now open" : camp.registrationPausedMessage}</div>
          <h1 className="hero-title" data-testid="hero-headline">
            {heroLines.map((line, index) => <div className="line-mask" key={line}><span className="line-text" style={{ animationDelay: `${180 + index * 110}ms` }}>{line}</span></div>)}
          </h1>
          <p className="hero-kicker">Train. Compete. <em>Get Better.</em></p>
          <p className="hero-description">{camp.description}</p>
          <div className="hero-meta">
            <div className="hero-meta-item" data-testid="hero-date-info"><CalendarDays size={17} /><div><span>DATE</span><strong>{camp.date}</strong></div></div>
            <div className="hero-meta-item" data-testid="hero-location-info"><MapPin size={17} /><div><span>LOCATION</span><strong>{camp.venue}<br />{camp.city}</strong></div></div>
          </div>
          <div className="hero-actions">
            <RegisterLink testId="hero-register-btn" />
            <a className="outline-link" href="#the-camp" data-testid="hero-learn-more-btn"><span>LEARN MORE</span><ArrowDown size={16} /></a>
          </div>
          <p className="hero-urgency">Limited spots available.</p>
        </div>
        <div className="hero-visual">
          <div className="hero-image-frame" style={{ transform: `translate3d(${tilt.x}px, ${tilt.y}px, 0)` }}>
            <img src={camp.images.hero} alt="Junior golfer executing a powerful fairway strike" />
            <div className="hero-image-badge"><span>01</span><strong>THE FIRST<br />CAMP</strong></div>
            <div className="hero-image-note">BIRMINGHAM, AL / 2026</div>
          </div>
          <div className="hero-image-caption"><span>OAK MOUNTAIN STATE PARK GOLF COURSE</span><span>AGES 7–18</span></div>
        </div>
      </div>
      <a className="hero-scroll-cue" href="#the-camp" data-testid="hero-scroll-link"><span>Scroll to explore</span><ArrowDown size={15} /></a>
    </section>
  );
}

export default HeroSection;
